import { useContext, createContext } from 'react';

// -- Dashboard context types ----------------------------------------

// Panel keys are defined explicitly here to avoid importing the
// component map from useSidePanel (which would create a cyclic
// dependency through the side-panel components).
type PanelKey =
  | 'CompletionsProgressions'
  | 'PastDue'
  | 'Revisions'
  | 'EnrolmentHealth'
  | 'DueNextMonth'
  | 'SemesterProgress'
  | 'Engagement'
  | 'TwoWeekEngagement'
  | 'WorkPlacements';

export type DashboardContextType = {
  PanelContentComponent: React.ComponentType | null;
  panelProps: Record<string, unknown> | null;
  openPanel: (key: PanelKey, props?: Record<string, unknown>) => void;
  closePanel: () => void;
};

// -- Context and hook -----------------------------------------------

export const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

export default function useDashboardContext(): DashboardContextType {
  const context = useContext(DashboardContext);
  if (context === undefined) {
    throw new Error('useDashboardContext must be used within a DashboardProvider');
  }
  return context;
}
